import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    isRequesting: false,
    error: null,
    // Danh sách bảng kê tổng hợp thu tiền
    data: {},
    total: 0,
    searchCriteria: {},
    // [Nộp tiền] Danh sách bảng kê tổng hợp thu tiền
    dataChecker: [],
    // totalChecker: 0,

    // [Lịch sử ] Danh sách bảng kê tổng hợp thu tiền
    dataDepositOrder: {},
    searchCriteriaDepositOrder: {},
};
const slice = createSlice({
    name: 'summaryStatementOfReceipt',
    initialState: initialState,
    reducers: {
        get_list: (state, action) => {
            return {
                ...state,
                isRequesting: true,
                error: null,
                searchCriteria: { ...action.payload },
            };
        },
        get_list_succeed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                data: action.payload,
                total: action.payload?.total || 0,
            };
        },
        get_list_failed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: action.payload.error,
                data: [],
                total: 0,
            };
        },

        get_list_checker: (state) => {
            return {
                ...state,
                isRequesting: true,
                error: null,
            };
        },
        get_list_checker_succeed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                dataChecker: action.payload,
                // totalChecker: action.payload?.total || 0,
            };
        },
        get_list_checker_failed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: action.payload.error,
                dataChecker: [],
                totalChecker: 0,
            };
        },
        get_deposit_order: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                dataDepositOrder: {},
                searchCriteriaDepositOrder: action?.payload,
            };
        },
        save_deposit_order: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                dataDepositOrder: action.payload,
            };
        },

        save_checker_deposit: (state) => {
            return {
                ...state,
                isRequesting: true,
            };
        },
        save_checker_deposit_succeed: (state) => {
            return {
                ...state,
                isRequesting: false,
            };
        },
        deposit_order_confirm: (state) => {
            return {
                ...state,
                isRequesting: true,
            };
        },
        deposit_order_confirm_succeed: (state) => {
            return {
                ...state,
                isRequesting: false,
            };
        },
        reset_state: () => {
            return initialState;
        },
    },
});

export const { reducer, actions } = slice;

export default reducer;
